import React, { useCallback, useMemo, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Flex, MultiSelector, Text } from '@leverege/ui-elements'
import { FilterSourceModel } from '@leverege/molten/filters'

import { LoadingView } from '@leverege/molten/views'
import LineCard from './LineCard'

import S from './LiveLineStatusComponent.css'
import { sortLinesByActivity } from './Util'

export default function DemoComponent( props ) {
  const { dispatch, delegate, data, filterName, filter, onFilterChange, ...rest } = props
  const filteredLinesArray = data.items

  // data is my filtered data, lines now is my unfiltered lines. do dropdown  based on lines, cards etc based on data

  useEffect( () => {
    dispatch( delegate?.list( { queryName : 'test' } ) )
  }, [ dispatch, delegate ] )
  
  const allLinesArray = useSelector( ( state ) => {
    return delegate.getList( state, { queryName : 'test' } )?.items
  } )

  const values = useMemo( () => {
    return allLinesArray?.map( ( item ) => {
      return {
        name : item?.name,
        value : item?.id
      }
    } )
  }, [ allLinesArray ] )
  
  const value = useMemo( () => {
    return FilterSourceModel.getMetadata( filter )
  }, [ filter ] )

  const onChangeFilter = useCallback( ( { value : v } ) => {
    let f = FilterSourceModel.create()
    const conditions = []
    if ( v && v.length > 0 ) {
      conditions.push( {
        type : 'equals',
        field : 'id',
        value : v
      } )
    }

    if ( conditions.length > 0 ) {
      f = FilterSourceModel.setFilter( f, {
        type : 'logical',
        operator : 'and',
        conditions
      } )
    }
    f = FilterSourceModel.setMetadata( f, v )
    onFilterChange( { data : filterName, value : f } )
  }, [ filterName, onFilterChange ] )
  
  if ( values == null ) return <LoadingView />

  return (
    <Flex variant="colMStart">
      <Flex variant="lineHeader" className={S.header}>
        <Text variant="detailTitle">Live Status</Text>
        <MultiSelector
          emptyLabel="View All Lines"
          selectionType="text"
          values={values}
          value={value}
          onChange={onChangeFilter} />
      </Flex>
      <Flex className={S.lines} variant="rowM">
        {filteredLinesArray.sort( sortLinesByActivity ).map( line => <LineCard {...rest} line={line} key={line.id} /> )}
      </Flex>
    </Flex>
  )
}
